import { Flex, Label, Span, Range } from '@fareye/ui'
import { formatMs, hhmmADoMMMYYYY, isEmpty } from '@fareye/utils'
import React from 'react'
import {
  ExceptionStoppageGroup,
  TripDetailsGroup,
  TripLabel,
  TripLabelDetail
} from '../../../style/styled'
import { labelColor } from '../../../utility/colors'
import { tripDetailConstant } from '../../../utility/constants'
import { DailyDistanceGraph } from './DailyDistanceGraph'

const TripDetails = ({
  data,
  plant,
  trip,
  historySlider,
  stoppageSlider,
  overspeedSlider,
  currHistorySlider,
  currStoppageSlider,
  currOverspeedSlider,
  currExceptionSlider,
  setCurrHistorySlider,
  setCurrStoppageSlider,
  setCurrOverspeedSlider,
  isShare,
  tripTabItems,
  apiBased
}: any) => {
  const [stoppageValue, setStoppageValue] = React.useState(
    currStoppageSlider ? currStoppageSlider : null
  )

  const [historyValue, setHistoryValue] = React.useState({
    min: currHistorySlider.min,
    max: currHistorySlider.max
  })

  const [overspeedValue, setOverspeedValue] = React.useState(
    currOverspeedSlider
  )

  React.useEffect(() => {
    setStoppageValue(currStoppageSlider ? currStoppageSlider : null)
  }, [currStoppageSlider])

  return (
    <Flex p={3} column>
      {plant === trip?.origin?.toLowerCase() || plant === '' ? (
        <TripDetailsGroup column>
          <Span color={labelColor.normalText}>
            {tripDetailConstant.loading}
          </Span>
          <TripLabelDetail style={{ width: '100%' }}>
            <Span style={{ width: '30px', display: 'inline-block' }}>In</Span>
            <Span style={{ width: '10px', display: 'inline-block' }}>-</Span>
            {trip?.loadingInTime ? hhmmADoMMMYYYY(trip.loadingInTime) : '-'}
          </TripLabelDetail>
          <TripLabelDetail style={{ width: '100%' }}>
            <Span style={{ width: '30px', display: 'inline-block' }}>Out</Span>
            <Span style={{ width: '10px', display: 'inline-block' }}>-</Span>
            {trip?.loadingOutTime ? hhmmADoMMMYYYY(trip.loadingOutTime) : '-'}
          </TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {plant === trip?.destination?.toLowerCase() || plant === '' ? (
        <TripDetailsGroup style={{ marginTop: 20 }} column>
          <Span color={labelColor.normalText}>
            {tripDetailConstant.unloading}
          </Span>
          <TripLabelDetail style={{ width: '100%' }}>
            <Span style={{ width: '30px', display: 'inline-block' }}>In</Span>
            <Span style={{ width: '10px', display: 'inline-block' }}>-</Span>
            {trip?.unloadingInTime
              ? hhmmADoMMMYYYY(trip.unloadingInTime)
              : 'N.A.'}
          </TripLabelDetail>
          <TripLabelDetail style={{ width: '100%' }}>
            <Span style={{ width: '30px', display: 'inline-block' }}>Out</Span>
            <Span style={{ width: '10px', display: 'inline-block' }}>-</Span>
            {trip?.unloadingOutTime
              ? hhmmADoMMMYYYY(trip.unloadingOutTime)
              : 'N.A.'}
          </TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.startDate ? (
        <TripDetailsGroup style={{ marginTop: 20 }}>
          <TripLabel>{tripDetailConstant.startTime}</TripLabel>
          <TripLabelDetail>
            {trip?.startDate !== null ? hhmmADoMMMYYYY(trip.startDate) : 'N.A.'}
          </TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.closedDate ? (
        <TripDetailsGroup>
          <TripLabel>{tripDetailConstant.closureTime}</TripLabel>
          <TripLabelDetail>
            {trip?.closedDate !== null
              ? hhmmADoMMMYYYY(trip.closedDate)
              : 'N.A.'}
          </TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.closureReason ? (
        <TripDetailsGroup>
          <TripLabel>{tripDetailConstant.closureReason}</TripLabel>
          <TripLabelDetail>{trip.closureReason}</TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.closedBy ? (
        <TripDetailsGroup>
          <TripLabel>{tripDetailConstant.closedBy}</TripLabel>
          <TripLabelDetail>{trip.closedBy}</TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.sta ? (
        <TripDetailsGroup>
          <TripLabel>{tripDetailConstant.sta}</TripLabel>
          <TripLabelDetail>{hhmmADoMMMYYYY(trip.sta)}</TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.trackingProvider ? (
        <TripDetailsGroup>
          <TripLabel>{tripDetailConstant.trackingProvider}</TripLabel>
          <TripLabelDetail>{trip?.trackingProvider}</TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.driverName ? (
        <TripDetailsGroup style={{ marginTop: 20 }}>
          <TripLabel>{tripDetailConstant.driverName}</TripLabel>
          <TripLabelDetail>{trip.driverName}</TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {trip?.driverPhoneNo ? (
        <TripDetailsGroup>
          <TripLabel>{tripDetailConstant.phoneNo}</TripLabel>
          <TripLabelDetail>{trip.driverPhoneNo}</TripLabelDetail>
        </TripDetailsGroup>
      ) : null}
      {tripTabItems.map((item: any) => {
        const { key, label } = item
        return (
          <TripDetailsGroup key={key}>
            <TripLabel>{label}</TripLabel>
            <TripLabelDetail>{trip[key] ? trip[key] : '-'}</TripLabelDetail>
          </TripDetailsGroup>
        )
      })}
      {!isEmpty(data?.stoppages) && stoppageValue ? (
        <ExceptionStoppageGroup column>
          <Span color={labelColor.normalText}>
            {tripDetailConstant.stoppage}
          </Span>
          <Range
            formatLabel={(value: any) => formatMs(value)}
            maxValue={stoppageSlider.max}
            minValue={stoppageSlider.min}
            value={stoppageValue}
            onChange={(value: any) => setStoppageValue(value)}
            onChangeComplete={(value: any) => setCurrStoppageSlider(value)}
          />
        </ExceptionStoppageGroup>
      ) : null}
      {!isEmpty(data.overspeedInstances) && data.overspeedInstances.length ? (
        <Flex p={2} column style={{ marginBottom: '20px' }}>
          <Label
            variant={'h6'}
            style={{ fontWeight: 700, marginBottom: '24px' }}
          >
            {tripDetailConstant.overspeedInstances}
          </Label>
          <Range
            maxValue={overspeedSlider.max}
            minValue={overspeedSlider.min}
            value={overspeedValue}
            onChange={(value: any) => {
              setOverspeedValue(value)
            }}
            onChangeComplete={(value: any) => setCurrOverspeedSlider(value)}
          />
        </Flex>
      ) : null}
      {!isEmpty(data.histories) && data.histories.length > 1 ? (
        <ExceptionStoppageGroup column>
          <Span color={labelColor.normalText}>
            {tripDetailConstant.history}
          </Span>
          <Flex style={{ margin: '0 auto', padding: '25px 0', width: '80%' }}>
            <Range
              formatLabel={(value: any) => hhmmADoMMMYYYY(value)}
              maxValue={historySlider.max}
              minValue={historySlider.min}
              value={historyValue}
              onChange={(value: any) => setHistoryValue(value)}
              onChangeComplete={setCurrHistorySlider}
              containerStyle={{ width: '100%' }}
            />
          </Flex>
        </ExceptionStoppageGroup>
      ) : null}
      {!isEmpty(data.histories) && isShare ? (
        <DailyDistanceGraph
          slug={trip.slug}
          histories={data.histories}
          apiBased={apiBased}
        />
      ) : null}
    </Flex>
  )
}

export default TripDetails
